import { LayoutModule } from '../../../../layout/modules';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    FUNCTIONARIES_SWITCHBOARD,
    FUNCTIONARIES_SWITCHBOARD_EDIT,
    FUNCTIONARIES_SWITCHBOARD_NEW,
    FUNCTIONARIES_SWITCHBOARD_DETAIL,
} from '../../../../../routes/paths';

import { useFunctionariesSwitchDetail } from './hook';

import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { FunctionariesSwitchData } from './data';
import { FunctionariesSwitchHistorical } from '../historical';
import { FunctionariesSwitchRegisterHistory } from './registerHistory';

export const FunctionariesSwitchDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        functionarieSwitch,
        loading,
        functionarieSwitchHistorical,
        showHistorical,
        setShowHistorical,
    } = useFunctionariesSwitchDetail();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle funcionario"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={functionarieSwitch?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FUNCTIONARIES_SWITCHBOARD_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: FUNCTIONARIES_SWITCHBOARD_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD_DETAIL,
                        }}
                        buttonLog={{
                            show: true,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <FunctionariesSwitchHistorical
                            historical={functionarieSwitchHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <FunctionariesSwitchData
                        functionariesSwitch={functionarieSwitch}
                        loading={loading}
                    />
                </LayoutModule>

                <FunctionariesSwitchRegisterHistory
                    functionariesSwitch={functionarieSwitch}
                />
            </LayoutModule>
        </>
    );
};
